import styled from "styled-components";

export const RowBox = styled.div`
  display: flex;
  height: 48px;
  justify-content: space-between;
  align-items: center;
`;

export const LeftBox = styled.div`
  flex: 0 0 ${props => props.width || '240px'};
  display: flex;
  align-items: center;
`;

export const RightBox = styled.div`
  flex: 1;
  align-items: flex-end;
`;

export const ColumnBox = styled.div`
  display: flex;
  flex-direction: column;
`;

export const TopBox = styled.div`
  padding: 16px 0 0 0;
`;

export const BottomBox = styled.div`
  padding: 32px 0 0 0;
`;